import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SparkEffect from './components/SparkEffect';
import SEOHead from './components/SEOHead';
import './App.css';
import './responsive.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <SEOHead />
          <SparkEffect />
          <Navbar />
          <main id="main-content">
            <Routes>
              <Route path="/" element={
                <>
                  <Hero />
                  <About />
                  <Experience />
                  <Skills />
                  <Projects />
                  <Gallery />
                  <Contact />
                </>
              } />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;